import { Icon } from "@artprov/design-system";
import HeadingGroup from "../../common/components/headingGroup/HeadingGroup";
import { useComprasAuth } from "../../common/hooks/useComprasAuth";

/**
 * Página mostrada cuando el usuario no tiene el rol requerido
 * para acceder a la aplicación de Compras.
 */
const NoAccess = () => {
    const { username, email } = useComprasAuth();
    const portalUrl = "https://portal.artprovincia.ar";

    return (
        <div className="mt-4">
            {/* Heading consistente con otras páginas */}
            <HeadingGroup
                title="Acceso Denegado"
                description={`Tu usuario ${username || email || "(desconocido)"} no posee permisos para acceder a la aplicación de Compras.`}
                className="mb-6"
            />

            {/* Contenido principal */}
            <div className="flex flex-col items-center justify-center py-12">
                {/* Icono de Acceso Denegado */}
                <div className="flex justify-center mb-6">
                    <div className="rounded-full bg-red-100 p-6">
                        <Icon name="block" className="text-red-600" style={{ fontSize: '64px' }} />
                    </div>
                </div>

                {/* Mensaje adicional */}
                <p className="text-lg text-gray-700 mb-2 text-center max-w-lg">
                    Si necesitas acceso, por favor contacta al área de Sistemas o Seguridad Informática.
                </p>

                {/* Link al Portal */}
                <a
                    href={portalUrl}
                    className="inline-flex items-center gap-2 px-6 py-3 bg-blue-600 text-white 
                     font-semibold rounded-lg hover:bg-blue-700 transition-colors 
                     shadow-lg hover:shadow-xl mt-6"
                >
                    <Icon name="home" />
                    Volver al Portal de Aplicaciones
                </a>

                {/* Info adicional */}
                <div className="mt-8 p-4 bg-blue-50 rounded-lg">
                    <p className="text-sm text-gray-600">
                        <Icon name="info" className="inline-block mr-1" />
                        Permiso requerido:{" "}
                        <span className="font-mono font-semibold">acceso-compras</span>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default NoAccess;
